import { useState } from 'react';
import { Box, Slide } from '@mui/material';
import { Login } from './Login';
import { Register } from './Register';
import { useAuth } from '../hooks/useAuth';
import { ForgotPassword } from './ForgotPassword';

import { AuthScreens } from '../types';
import { ResetPasswordCode } from './ResetPasswordCode';
import { ResetPassword } from './ResetPassword';

export const Auth = () => {
  const [page, setPage] = useState<AuthScreens>('login');
  const [pageAttributte, setPageAttributte] = useState<string | undefined>(undefined);
  const { isAuthenticated } = useAuth();

  const handleLoginCallback = () => {
    setPageAttributte(undefined);
  };

  const handleNextPage = (nextPage: AuthScreens) => (pageAttributte?: string) => {
    setPageAttributte(pageAttributte);
    setPage(nextPage);
  };

  if (isAuthenticated) {
    return null;
  }

  const isLogin = page === 'login';
  const isRegister = page === 'register';
  const isForgotPassword = page === 'forgot-password';
  const isResetPassword = page === 'reset-password';
  const isCodeResetPassword = page === 'code-reset';

  return (
    <Box position="relative" flex={1}>
      <Slide direction={isLogin ? 'left' : 'right'} in={isLogin} mountOnEnter unmountOnExit>
        <Box display={isLogin ? 'flex' : 'none'} width="100%">
          <Login emailValue={pageAttributte} onChangeScreen={handleNextPage} onLoginCallback={handleLoginCallback} />
        </Box>
      </Slide>
      <Slide direction={isLogin ? 'right' : 'left'} in={isRegister} mountOnEnter unmountOnExit>
        <Box display={isRegister ? 'flex' : 'none'} width="100%">
          <Register onChangeScreen={handleNextPage} />
        </Box>
      </Slide>
      <Slide direction={isLogin ? 'right' : 'left'} in={isForgotPassword} mountOnEnter unmountOnExit>
        <Box display={isForgotPassword ? 'flex' : 'none'} width="100%">
          <ForgotPassword onChangeScreen={handleNextPage} />
        </Box>
      </Slide>
      <Slide direction={isLogin ? 'right' : 'left'} in={isCodeResetPassword} mountOnEnter unmountOnExit>
        <Box display={isCodeResetPassword ? 'flex' : 'none'} width="100%">
          <ResetPasswordCode email={pageAttributte} onChangeScreen={handleNextPage} />
        </Box>
      </Slide>
      <Slide direction={isLogin ? 'right' : 'left'} in={isResetPassword} mountOnEnter unmountOnExit>
        <Box display={isResetPassword ? 'flex' : 'none'} width="100%">
          <ResetPassword token={pageAttributte} onChangeScreen={handleNextPage} />
        </Box>
      </Slide>
    </Box>
  );
};
